import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity6 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_6;
}

export default CobbledRoadTileEntity6;
